import { PROFILE_IDS } from '@/core/constants/profileIds';

import { inject } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { CanActivateFn, Router } from "@angular/router";
import { SessionService } from "../session.service";
import { Settings } from "../models/settings";
import { filter, map, take } from "rxjs";

export const entryGuard: CanActivateFn = () => {
  const router = inject(Router);
  const sessionService: SessionService = inject(SessionService);

  return toObservable(sessionService.settings).pipe(
    filter(settings => !!settings),   // espera hasta tener valor
    take(1),
    map((settings: Settings) => {

      const subscriptionLevelId = sessionService.params()['profileId'];

      if ((settings.profiles?.length || 0) > 1 && !subscriptionLevelId) {
        return router.createUrlTree(['/profile-type']);
      }

      switch (subscriptionLevelId) {
        case PROFILE_IDS.BasicBeneficiary:
          return router.createUrlTree(['/credits']);
        default:
          return router.createUrlTree(['/payments']);
      }
    })
  );
};

